import React from "react";
import { Modal, Button } from "react-bootstrap";

interface Props {
  show: boolean;
  hasMorePending: boolean;
  onContinue: () => void;
  onExit: () => void;
}

const SubmitConfirmationModal: React.FC<Props> = ({
  show,
  hasMorePending,
  onContinue,
  onExit,
}) => {
  return (
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Evaluation Submitted</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ margin: 0 }}>
          {hasMorePending
            ? "Evaluation has been submitted successfully. There are more papers pending for evaluation."
            : "Evaluation has been submitted successfully. No more papers pending for this test."}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onExit}>
          Exit
        </Button>
        {hasMorePending && (
          <Button variant="primary" size="sm" onClick={onContinue}>
            Continue to Next Paper
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SubmitConfirmationModal;
